export default __webpack_public_path__ + "static/media/software-image-01.9c4f6269.png";